import { memo } from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube, FaTwitter, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { useBusinessConfig } from "../context/BusinessConfigContext";

const socialIcons = { facebook: FaFacebook, instagram: FaInstagram, linkedin: FaLinkedin, youtube: FaYoutube, twitter: FaTwitter };

const Footer = memo(() => {
  const config = useBusinessConfig();
  const { businessName, footer, social, contact, logo, businessHours } = config;

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row g-4 mb-4">
          {/* Brand */}
          <div className="col-lg-4">
            {logo
              ? <img src={logo} alt={businessName} style={{ height: 40, marginBottom: 12 }} />
              : <div style={{ fontSize: "1.4rem", fontWeight: 800, color: "var(--primary)", marginBottom: 12 }}>{businessName}</div>}
            <p style={{ color: "#64748b", fontSize: "0.9rem", marginBottom: 16 }}>{footer.tagline}</p>
            <div className="footer-social">
              {Object.entries(social).map(([key, url]) => {
                if (!url) return null;
                const Icon = socialIcons[key];
                return Icon ? <a key={key} href={url} target="_blank" rel="noreferrer" aria-label={key}><Icon /></a> : null;
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-sm-6 col-lg-2">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            {footer.links.map((l) => (
              <Link key={l.path} to={l.path} className="footer-link">{l.label}</Link>
            ))}
          </div>

          {/* Contact */}
          <div className="col-sm-6 col-lg-3">
            <h6 className="fw-bold mb-3">Contact</h6>
            <div className="d-flex gap-2 mb-2" style={{ fontSize: "0.875rem", color: "#64748b" }}>
              <FaPhone style={{ color: "var(--primary)", marginTop: 3, flexShrink: 0 }} />
              <a href={`tel:${contact.phone}`} style={{ color: "#64748b" }}>{contact.phone}</a>
            </div>
            <div className="d-flex gap-2 mb-2" style={{ fontSize: "0.875rem", color: "#64748b" }}>
              <FaEnvelope style={{ color: "var(--primary)", marginTop: 3, flexShrink: 0 }} />
              <a href={`mailto:${contact.email}`} style={{ color: "#64748b" }}>{contact.email}</a>
            </div>
            <div className="d-flex gap-2" style={{ fontSize: "0.875rem", color: "#64748b" }}>
              <FaMapMarkerAlt style={{ color: "var(--primary)", marginTop: 3, flexShrink: 0 }} />
              <span>{contact.address}</span>
            </div>
          </div>

          {/* Hours */}
          <div className="col-lg-3">
            <h6 className="fw-bold mb-3">Business Hours</h6>
            {businessHours.map((h, i) => (
              <div key={i} style={{ fontSize: "0.85rem", marginBottom: 6 }}>
                <span className="fw-500">{h.day}</span>
                <div style={{ color: "#64748b" }}>{h.hours}</div>
              </div>
            ))}
          </div>
        </div>

        <hr style={{ borderColor: "var(--border-color)" }} />
        <div className="text-center" style={{ color: "#64748b", fontSize: "0.85rem" }}>{footer.copyright}</div>
      </div>
    </footer>
  );
});

export default Footer;
